import React from "react";
import JSZip from "jszip";
import Papa from "papaparse";
import { cloneDeep } from "lodash";
import { saveAs } from "file-saver";
import { Col, Button, Menu, Dropdown, Select, Row } from "antd";
import { DownOutlined, DownloadOutlined } from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import "../styles/styles.css";

const FilterBar = withRouter(
  ({
    data,
    location,
    history,
    searchVal,
    setSearchVal,
    setSearchTerm,
    hasSimplifiedReport,
    setOrderIdVal,
    params,
    dropdownFilter,
    permission,
    setCurrentPage,
    setAttributionWindow,
  }) => {
    const exportData = permission.exportData;

    const handleMenuClick = e => {
      let key;
      if (e.key === "0") key = "All Time";
      if (e.key === "1") key = "Last 7 Days";
      if (e.key === "2") key = "Last 15 Days";
      if (e.key === "3") key = "Last 30 Days";
      if (e.key === "4") key = "Last 60 Days";
      if (e.key === "5") key = "Last 90 Days";

      if (hasSimplifiedReport) {
        let days;
        if (key === "All Time") days = null;
        if (key === "Last 7 Days") days = 7;
        if (key === "Last 15 Days") days = 15;
        if (key === "Last 30 Days") days = 30;
        if (key === "Last 60 Days") days = 60;
        if (key === "Last 90 Days") days = 90;

        setCurrentPage(1);
        setAttributionWindow(days);
      }

      params.delete("df");
      params.append("df", key);
      history.push(`${location.pathname}?${params.toString()}`);
    };

    const handleDateFilter = () => (
      <Menu onClick={handleMenuClick}>
        <Menu.Item key={0}>All Time</Menu.Item>
        <Menu.Item key={1}>Last 7 Days</Menu.Item>
        <Menu.Item key={2}>Last 15 Days</Menu.Item>
        <Menu.Item key={3}>Last 30 Days</Menu.Item>
        <Menu.Item key={4}>Last 60 Days</Menu.Item>
        <Menu.Item key={5}>Last 90 Days</Menu.Item>
      </Menu>
    );

    const handleChange = s => {
      setOrderIdVal("");
      params.delete("orderId");
      params.delete("search");
      if (s) params.append("search", s);

      if (hasSimplifiedReport) {
        setCurrentPage(1);
        setSearchTerm(s);
      }

      history.push(`${location.pathname}?${params.toString()}`);
    };

    return (
      <Row gutter={[8, 8]}>
        <Col id="basket-items-title" span={24}>
          Basket Items
        </Col>
        <Col xs={24} md={12}>
          <Select
            mode="tags"
            allowClear
            style={{
              width: "100%",
            }}
            placeholder="Search multiple basket items by name"
            onChange={handleChange}
            defaultValue={searchVal ? searchVal : []}
          />
        </Col>
        <Col xs={24} md={6}>
          <Dropdown overlay={handleDateFilter()}>
            <Button style={{ width: "100%" }}>
              {dropdownFilter ? dropdownFilter : "All Time"} <DownOutlined />
            </Button>
          </Dropdown>
        </Col>
        <Col xs={24} md={6}>
          {exportData && (
            <Button
              style={{ width: "100%" }}
              disabled={isEmpty(data) ? true : false}
              type="primary"
              block
              onClick={() => {
                try {
                  const zip = new JSZip();
                  const folder = zip.folder("Reports Campaign Basket Item");
                  let dupFileData = cloneDeep(data);
                  folder.file(`Basket Items.csv`, Papa.unparse(dupFileData));
                  zip.generateAsync({ type: "blob" }).then(
                    blob => {
                      saveAs(blob, "Campaigns");
                      return true;
                    },
                    function(e) {
                      console.log("error", e);
                      return false;
                    }
                  );
                } catch (err) {
                  console.log(err);
                }
              }}
            >
              <DownloadOutlined />
              {`Export CSV`}
            </Button>
          )}
        </Col>
      </Row>
    );
  }
);

export default FilterBar;
